import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  getUnitPlanResponse,
  getLessonPlanResponse,
  getAssessmentPlanResponse,
  getAssignmentPlanResponse,
} from '../../utils/Chatapi';
import { useChatContext } from '../../context/ChatContext';
import { useLocation } from 'react-router-dom';
import './style.css';

function Reply() {
  const { initialStart } = useChatContext();
  const location = useLocation();
  const predefinedAnswers = useMemo(() => location.state?.answers || {}, [location.state?.answers]);

  const [chatHistory, setChatHistory] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isBotTyping, setIsBotTyping] = useState(false);
  const chatEndRef = useRef(null);


  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatHistory, isBotTyping]);

  const apiFunction = {
    UnitPlanning: getUnitPlanResponse,
    LessonPlanning: getLessonPlanResponse,
    Assessment: getAssessmentPlanResponse,
    Assignments: getAssignmentPlanResponse,
  }[initialStart];

  // ⬇️ Automatically send first message from bot
  useEffect(() => {
    const sendInitialBotMessage = async () => {
      setIsBotTyping(true);
      let formattedHistory = '';
      for (const [question, answer] of Object.entries(predefinedAnswers)) {
        formattedHistory += `${question}: ${answer}\n`;
      }
     
      try {
        const res = await apiFunction('final', formattedHistory, predefinedAnswers);
        const botMessage = res.response || 'Hi! Ready to get started.';
        setChatHistory([{ sender: 'bot', message: botMessage }]);
      } catch (err) {
        console.error('Error loading initial message:', err);
        setChatHistory([{ sender: 'bot', message: '⚠️ Error starting conversation.' }]);
      } finally {
        setIsBotTyping(false);
      }
    };

    sendInitialBotMessage();
  }, [apiFunction, predefinedAnswers]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userInput.trim()) return;

    const updatedChat = [...chatHistory, { sender: 'user', message: userInput }];
    setChatHistory(updatedChat);
    setUserInput('');
    setIsBotTyping(true);

    let formattedHistory = '';
    for (const [question, answer] of Object.entries(predefinedAnswers)) {
      formattedHistory += `${question}: ${answer}\n`;
    }

    try {
      const res = await apiFunction(userInput, formattedHistory, predefinedAnswers);
      const botMessage = res.response || '...';
      setChatHistory(prev => [...prev, { sender: 'bot', message: botMessage }]);
    } catch (err) {
      console.error(err);
      setChatHistory(prev => [...prev, { sender: 'bot', message: '⚠️ Error calling API' }]);
    } finally {
      setIsBotTyping(false);
    }
  };

  return (
    <div className="chatbot-wrapper">
      <h2 className="chatbot-title">{initialStart} Chat Assistant</h2>

      <div className="chat-window">
        {chatHistory.map((msg, index) => (
          <div key={index} className={`chat-bubble ${msg.sender}`}>
            {/* {msg.message} */}
            {msg.message.split('\n').map((line, i) => (
      <div key={i}>{line}</div>
    ))}
          </div>
        ))}
        {isBotTyping && <div className="chat-bubble bot typing">Typing...</div>}
        <div ref={chatEndRef} />
      </div>

      <form className="chat-input-container" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Ask a question or describe what you need..."
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          className="chat-input"
        />
        <button type="submit" className="chat-send-btn">Submit</button>
      </form>
    </div>
  );
}

export default Reply;
